export default {
  data: function () {
    return {
      modalOpensCounter: 0,
    };
  },
  methods: {
    onModalShow: function () {
      this.modalOpensCounter += 1;
    },
  },
};
